"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASNStatus = void 0;
/**
 * Represents the possible states of an ASN.
 *
 * @enum {string}
 * @property {string} SENT - The ASN has been sent and the POFile has been moved to ASN_SENT state.
 * @property {string} FAILED - The ASN has failed to send and the POFile has been moved to ASN_FAILED state.
 */
var ASNStatus;
(function (ASNStatus) {
    ASNStatus["SENT"] = "SENT";
    ASNStatus["FAILED"] = "FAILED";
})(ASNStatus = exports.ASNStatus || (exports.ASNStatus = {}));
//# sourceMappingURL=ASNStatus.js.map